module.exports = __webpack_public_path__ + "img/check.8becc69f.svg";